// ACCOUNT SUBSCRIPTION — ACTIVATABLE PLANS *******************************************************
// pathname: /v1/account-subscriptions/plans
// method:   GET
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { ApiSchema } from '@type/api/apiUtilityFn';

export type SubscriptionPlan = ApiSchema<'SubscriptionPlanVersionRead'>;

interface UseSwrSubscriptionPlansProps {
  locale?: string;
  shouldFetch?: boolean;
}

/**
 * @description SWR: subscription plans that can be activated right now.
 *
 * Admin-only on the server (403 otherwise), so callers should pass
 * `shouldFetch: isAdmin` rather than relying on the error — a client opening the
 * page has no reason to fire a request that is going to be refused.
 */
export const useSwrSubscriptionPlans = (props?: UseSwrSubscriptionPlansProps) => {
  const { locale, shouldFetch = true } = props ?? {};

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<SubscriptionPlan[]>({
    url: '/v1/account-subscriptions/plans',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000 * 5, // 5 minutes — the plan list barely changes
    },
  });

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
